




















import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import userModule from '@/store/user'

@Component({
  name: 'ConfirmView'
})
class ConfirmView extends Vue {
  private message = 'Dein Account wird aktiviert …'
  private type = 'info'

  private async mounted() {
    const success = await userModule.confirmAccount({
      token: this.$route.params.token
    })

    if (success) {
      if (authModule.isLoggedIn) {
        authModule.fetchUser()
      }
      this.$router.push({ name: 'HomeView' })
    } else {
      this.type = 'error'
      this.message =
        'Dein Account konnte nicht bestätigt werden. Bitte überprüfe den Registrierungslink und versuche es erneut!'
    }
  }
}

export default ConfirmView
